var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentReadyToFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.964 5.765l.005.007 1.616 2.389h5.72c.18 0 .35.045.5.123a1.1 1.1 0 01.752.78l.001.004 1.405 5.424a1.119 1.119 0 01-.767 1.364 1.076 1.076 0 01-1.323-.78l-.001-.004-.285-1.097-1.371 7.098A1.11 1.11 0 0113.13 22h-1.416a1.11 1.11 0 01-1.084-.92L8.585 10.587l-2.39-3.53A1.14 1.14 0 016.464 5.5a1.06 1.06 0 011.501.265zM12.155 2c1.345 0 2.436 1.128 2.436 2.52 0 1.391-1.09 2.52-2.436 2.52-1.345 0-2.436-1.129-2.436-2.52C9.72 3.128 10.81 2 12.155 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentReadyToFill);
export default __webpack_public_path__ + "1eb4b0c9b832a34ecc418f5083d94575.svg";
export { ForwardRef as ReactComponent };